import { render } from "./SiteNotice.vue?vue&type=template&id=84bf10c8&scoped=true"
import script from "./SiteNotice.vue?vue&type=script&lang=js"
export * from "./SiteNotice.vue?vue&type=script&lang=js"

import "./SiteNotice.vue?vue&type=style&index=0&id=84bf10c8&scoped=true&lang=css"

import exportComponent from "C:\\_TimetipCode\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84bf10c8"]])

export default __exports__